const convertTimeDataFromBackend = (time: string): string => {
  const timeParts = new Date().toString().split(' ')
  const timezone = timeParts[5]
  const date = timeParts.splice(1, 3).join(' ')
  const hoursTime = time.toString().split(' ')[3]
  return `${date} ${hoursTime} ${timezone}`
}

export default convertTimeDataFromBackend
